import { Table, Note } from '@convergence/components';
import { useAnalysisQuery } from '../api/queries/analysis';
import { useAnalysisCostQuery } from '../api/queries/analysisCost';

export interface CostProps {
  slug: string;
}

export function Cost(props: CostProps) {
  const analysisQuery = useAnalysisQuery(props.slug);
  const {
    data: costData,
    isLoading,
    isError,
    error
  } = useAnalysisCostQuery(props.slug);
  if (error) {
    console.log(error);
  }
  if (analysisQuery.isLoading || isLoading || !costData) {
    return <SkeletonCost />;
  }
  if (analysisQuery.data?.status === 'PENDING') {
    return (
      <div className="text-gray-500">
        Cost not available until analysis is completed
      </div>
    );
  }
  const tableData = [];
  tableData.push({
    Name: 'Total',
    Cost: costData.totalCost.toFixed(2)
  });

  if (analysisQuery.data?.status === 'COMPLETED') {
    tableData.push({
      Name: 'Storage',
      Cost: costData.storageCost.toFixed(2)
    });
    tableData.push({
      Name: 'VPC',
      Cost: costData.vpcCost.toFixed(2)
    });
    if (costData.runner === 0 && costData.tasks.length === 0) {
      tableData.push({
        Name: 'Tasks',
        Cost: (
          costData.totalCost -
          costData.storageCost -
          costData.vpcCost
        ).toFixed(2)
      });
    } else {
      tableData.push({
        Name: 'Runner Job',
        Cost: costData.runner.toFixed(2)
      });
      const grouped: Record<string, { Name: string; Cost: number }> = {};
      for (const task of costData.tasks) {
        const name = task.name;
        if (!name) continue;
        if (!grouped[name]) {
          grouped[name] = { Name: name, Cost: task.cost };
        } else {
          grouped[name] = {
            ...grouped[name],
            Cost: task.cost + grouped[name].Cost
          };
        }
      }
      for (const group of Object.values(grouped)) {
        tableData.push({
          Name: group.Name,
          Cost: group.Cost.toFixed(2)
        });
      }
    }
  }

  return (
    <div className="flex flex-col gap-4 p-8 overflow-auto">
      <Table
        data={tableData}
        renderHeading={(children) => (
          <tr className="bg-black text-white">{children}</tr>
        )}
        cell={({ children }) => <td className="p-2">{children}</td>}
        row={({ children }) => (
          <tr className="border-b border-black">{children}</tr>
        )}
        render={{ Cost: (value) => `$${value.Cost}` }}
      />
    </div>
  );
}

export function SkeletonCost() {
  const count = 10;
  const a = Array.from({ length: count }, (_, i) => i);
  return (
    <div className="flex flex-col gap-4 p-8">
      {a.map((i) => (
        <div
          className="h-6 rounded animate-pulse w-full grid grid-cols-12 grid-rows-1"
          key={i}
        >
          <div className="col-span-9 w-full h-full bg-gray-200 "></div>
          <div className="col-span-1 col-start-12 w-full h-full bg-gray-200 "></div>
          <div></div>
        </div>
      ))}
    </div>
  );
}
